module.exports = __webpack_public_path__ + "img/btn_google_signin_dark_focus_web.852a96b2.png";